/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressDto,
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    FailureCreatorTypes,
    FailureCreatorTypesFromJSON,
    FailureCreatorTypesFromJSONTyped,
    FailureCreatorTypesToJSON,
    PhoneDto,
    PhoneDtoFromJSON,
    PhoneDtoFromJSONTyped,
    PhoneDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateFailureCommand
 */
export interface CreateFailureCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    identifier?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateFailureCommand
     */
    reportedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateFailureCommand
     */
    closedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateFailureCommand
     */
    deadline?: Date;
    /**
     * 
     * @type {AddressDto}
     * @memberof CreateFailureCommand
     */
    address?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    typeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    expanseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    description1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    natureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    description2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    optimalDeadlineDaysId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    statusId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    stateChangeReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    parentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    contractorId?: string | null;
    /**
     * 
     * @type {FailureCreatorTypes}
     * @memberof CreateFailureCommand
     */
    creatorType?: FailureCreatorTypes;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    notifierFamilyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    notifierMiddlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    notifierForename?: string | null;
    /**
     * 
     * @type {PhoneDto}
     * @memberof CreateFailureCommand
     */
    notifierPhone?: PhoneDto;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    notifierEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFailureCommand
     */
    repairmanIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFailureCommand
     */
    townId?: string | null;
}

export function CreateFailureCommandFromJSON(json: any): CreateFailureCommand {
    return CreateFailureCommandFromJSONTyped(json, false);
}

export function CreateFailureCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFailureCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deviceId': !exists(json, 'deviceId') ? undefined : json['deviceId'],
        'identifier': !exists(json, 'identifier') ? undefined : json['identifier'],
        'reportedAt': !exists(json, 'reportedAt') ? undefined : (new Date(json['reportedAt'])),
        'closedAt': !exists(json, 'closedAt') ? undefined : (json['closedAt'] === null ? null : new Date(json['closedAt'])),
        'deadline': !exists(json, 'deadline') ? undefined : (new Date(json['deadline'])),
        'address': !exists(json, 'address') ? undefined : AddressDtoFromJSON(json['address']),
        'typeId': json['typeId'],
        'expanseId': !exists(json, 'expanseId') ? undefined : json['expanseId'],
        'description1': !exists(json, 'description1') ? undefined : json['description1'],
        'natureId': !exists(json, 'natureId') ? undefined : json['natureId'],
        'description2': !exists(json, 'description2') ? undefined : json['description2'],
        'optimalDeadlineDaysId': !exists(json, 'optimalDeadlineDaysId') ? undefined : json['optimalDeadlineDaysId'],
        'statusId': !exists(json, 'statusId') ? undefined : json['statusId'],
        'stateChangeReason': !exists(json, 'stateChangeReason') ? undefined : json['stateChangeReason'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'contractorId': !exists(json, 'contractorId') ? undefined : json['contractorId'],
        'creatorType': !exists(json, 'creatorType') ? undefined : FailureCreatorTypesFromJSON(json['creatorType']),
        'notifierFamilyname': !exists(json, 'notifierFamilyname') ? undefined : json['notifierFamilyname'],
        'notifierMiddlename': !exists(json, 'notifierMiddlename') ? undefined : json['notifierMiddlename'],
        'notifierForename': !exists(json, 'notifierForename') ? undefined : json['notifierForename'],
        'notifierPhone': !exists(json, 'notifierPhone') ? undefined : PhoneDtoFromJSON(json['notifierPhone']),
        'notifierEmail': !exists(json, 'notifierEmail') ? undefined : json['notifierEmail'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'repairmanIds': !exists(json, 'repairmanIds') ? undefined : json['repairmanIds'],
        'townId': !exists(json, 'townId') ? undefined : json['townId'],
    };
}

export function CreateFailureCommandToJSON(value?: CreateFailureCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deviceId': value.deviceId,
        'identifier': value.identifier,
        'reportedAt': value.reportedAt === undefined ? undefined : (value.reportedAt.toISOString()),
        'closedAt': value.closedAt === undefined ? undefined : (value.closedAt === null ? null : value.closedAt.toISOString()),
        'deadline': value.deadline === undefined ? undefined : (value.deadline.toISOString()),
        'address': AddressDtoToJSON(value.address),
        'typeId': value.typeId,
        'expanseId': value.expanseId,
        'description1': value.description1,
        'natureId': value.natureId,
        'description2': value.description2,
        'optimalDeadlineDaysId': value.optimalDeadlineDaysId,
        'statusId': value.statusId,
        'stateChangeReason': value.stateChangeReason,
        'parentId': value.parentId,
        'contractorId': value.contractorId,
        'creatorType': FailureCreatorTypesToJSON(value.creatorType),
        'notifierFamilyname': value.notifierFamilyname,
        'notifierMiddlename': value.notifierMiddlename,
        'notifierForename': value.notifierForename,
        'notifierPhone': PhoneDtoToJSON(value.notifierPhone),
        'notifierEmail': value.notifierEmail,
        'comment': value.comment,
        'repairmanIds': value.repairmanIds,
        'townId': value.townId,
    };
}


